const fallbackRate = '1.021703';
export const SAR_TO_AED_CONVERSION_RATE = parseFloat(
  (
    1 / parseFloat(process.env.NEXT_PUBLIC_SAR_TO_AED_CONV_RATE || fallbackRate)
  ).toFixed(10),
);
